/** The "Min. hours" steps; mirrors MIN_HOURS_LEVELS in server/services/user-experience.service.ts,
 *  which returns a facet's countAtLeast in this order. 0 = any hours. */
export const MIN_HOURS_LEVELS = [10, 50, 100];

/** People for a facet option at a min-hours level: `count` for any, else its countAtLeast entry. */
export const countAtLevel = (option: { count: number; countAtLeast?: number[] }, minHours: number) => {
  if (!minHours) return option.count;
  const i = MIN_HOURS_LEVELS.indexOf(minHours);
  return i >= 0 ? (option.countAtLeast?.[i] ?? option.count) : option.count;
};

/** Row label for the period and min-hours rows, same width so their buttons line up. */
export const ControlLabel = ({ children }: { children: string }) => (
  <span style={{ fontSize: 11, color: '#999', width: 64, flexShrink: 0 }}>{children}</span>
);

/** Keeps the period, min-hours, and/or and search controls in view while the list scrolls.
 *  On phones the scroll container (shared/Modal) has 15px top padding, so stick 15px higher and pad
 *  the same, or rows show through above the controls. */
export const stickyControls = (isMobile: boolean) => ({
  position: 'sticky' as const, zIndex: 1, backgroundColor: 'white', paddingBottom: 4,
  ...(isMobile ? { top: -15, paddingTop: 15 } : { top: 0 }),
});

interface Props {
  value: number;
  onChange: (minHours: number) => void;
  /** When exactly one option is selected: its counts, shown on each step. */
  counts?: { count: number; countAtLeast?: number[] };
}

const MinHoursSelector = ({ value, onChange, counts }: Props) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 12, flexWrap: 'wrap' }}>
    <ControlLabel>Min. hours</ControlLabel>
    {[0, ...MIN_HOURS_LEVELS].map(h => {
      const active = value === h;
      return (
        <button
          key={h}
          onClick={() => onChange(h)}
          style={{
            fontSize: 11,
            fontWeight: 500,
            padding: '4px 10px',
            borderRadius: 6,
            cursor: 'pointer',
            border: 'none',
            backgroundColor: active ? '#38566B' : '#f0f0f0',
            color: active ? 'white' : '#888',
            transition: 'background-color 0.15s, color 0.15s',
            userSelect: 'none',
          }}
        >
          {h ? `${h}h+` : 'Any'}
          {counts && <span style={{ opacity: 0.7, marginLeft: 4 }}>· {countAtLevel(counts, h)}</span>}
        </button>
      );
    })}
  </div>
);

export default MinHoursSelector;
